<!-- 设置 -->
<template>
  <div class="grid-view tab-fcl-setting">
    <div style="margin: 10px;">
      <el-button no="onSave" type="success" @click="onSave()">{{ $t('Pricing.Save') }}</el-button>
      <el-button no="onRefresh" type="primary" @click="onRefresh()">{{ $t('Pricing.Refresh') }}</el-button>
      <el-button no="onAdd" type="primary" @click="onAdd()">{{ $t('Pricing.Add') }}</el-button>
      <el-button no="onDel" type="danger" :disabled="!selectedCount" @click="onDel()">{{ $t('Pricing.Delete') }}</el-button>
      <el-button no="onCancel" type="success" @click="onCancel()">{{ $t('Pricing.Cancel') }}</el-button>
    </div>
    <div class="search">
      <span class="label-center">{{ $t('Pricing.Search') }}</span>
      <span class="label-center">{{ $t('Pricing.Carrier_Air') }}</span>
      <el-input v-model="searchValue" no="searchValue" style="flex: 1" />
    </div>
    <markup-air-data-grid
      ref="markupGrid"
      :row-data="filterData"
      style="width: 100%"
      :editable="true"
      :grid-options="gridOptions"
    />
  </div>
</template>

<script>

import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import { AirApproveSettings } from '@/views/cargo/v0/Price/PriceAir/components/airApproveSettings'
import MarkupAirDataGrid from '@/views/cargo/v0/Price/PriceAir/components/markupAirDataGrid'
import { saveOrUpdateConfig } from '@/api/user'
import { MultiCompanyUtil } from '@/class/cargo/model/utils/MultiCompanyUtil'
export default {
  name: 'TabAirApproveSettings',
  components: { MarkupAirDataGrid },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      searchValue: '',
      rowData: [],
      source: [],
      selectedCount: 0,
      cfg: null,
      isHQManager: false,
      fullscreenLoading: false,
      hasAdd: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 单击显示编辑
        singleClickEdit: true,
        // 添加编辑组件
        frameworkComponents: {
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor
        },
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          console.log('rows===', rows)
          this.selectedCount = rows.length
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    filterData() {
      const { searchValue, source } = this
      if (!searchValue.trim()) {
        return source
      } else {
        const filterKeys = ['pol', 'pod', 'carrier']
        return source.filter(row => {
          let value = ''
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (key === 'pol') {
              value = this.$refs['markupGrid'].getPortLabel(row, 'pol')
            }
            if (key === 'pod') {
              value = this.$refs['markupGrid'].getPortLabel(row, 'pod')
            }
            if (key === 'carrier') {
              value = this.$refs['markupGrid'].filterDataGridColumnCarrierFunc(row[key])
            }
            if (row[key] && value.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1) return true
          }
        })
      }
    }
  },
  watch: {},
  methods: {
    async init(airConfigUtil) {
      this.isHQManager = MultiCompanyUtil.getInstance().isHQManager('PriceAir')
      this.markupSelectRow = null
      this.airConfigUtil = airConfigUtil
      if (this.airConfigUtil['_isMarkupSettingsLoaded']) {
        this.onSettingsLoaded()
      }
    },
    onSettingsLoaded() {
      this.cfg = this.airConfigUtil.markupCfg
      if (!this.cfg) {
        if (this.airConfigUtil.markupCfgDef) {
          this.cfg = {}
          this.airConfigUtil.markupCfg = this.cfg
          if (this.isHQManager) {
            this.cfg.officeId = 1
          } else {
            this.cfg.officeId = this.$store.getters.currentOfficeId
          }
          this.cfg.isOverrideable = false
          this.cfg.configId = this.airConfigUtil.markupCfgDef.configId
          this.cfg.value = {}
        } else {
          this.$message.warning(this.$t('Pricing.NoSetting'))
          return
        }
      }
      this.decodeSetting()
    },
    decodeSetting() {
      if (this.airConfigUtil.markupCfg.value.indexOf('setting') > 0) {
        const cfg = this.airConfigUtil.markupCfgValue['setting']
        if (cfg === null) {
          this.source = []
          return
        }
        const sources = []
        cfg.forEach(item => {
          sources.push(new AirApproveSettings(item))
        })
        this.source = sources
      } else {
        this.source = []
      }
    },
    onSave() {
      if (!this.isValid()) {
        return false
      }
      if (this.source.length > 0) {
        this.source.forEach((item) => {
          if (!item.carrier) {
            item.carrier = 0
          }
          if (!item.pol) {
            item.pol = 'ALLRG'
          }
          if (!item.pod) {
            item.pod = 'ALLRG'
          }
          if (!item.region) {
            item.region = 'ALLRG'
          }
        })
      }
      this.cfg.value = JSON.stringify({ setting: this.source })
      saveOrUpdateConfig(this.cfg).then((res) => {
        this.$message.success(this.$t('Pricing.Finished'))
        this.airConfigUtil.markupCfg = res.data
        this.airConfigUtil.decodeMarkupSetting()
        this.hasAdd = false
        this.onCancel()
      })
    },
    onRefresh() {
      this.decodeSetting()
      this.selectedCount = 0
    },
    onAdd() {
      this.source.push(new AirApproveSettings({}))
      this.hasAdd = true
    },
    onDel() {
      const api = this.gridOptions.api
      const selRows = api.getSelectedRows() // 获取选中的行
      api.updateRowData({ remove: selRows })
      const rowData = []
      api.forEachNode(node => rowData.push(node.data))
      this.source = rowData
      this.selectedCount = 0
    },
    onCancel() {
      if (this.hasAdd) {
        this.$confirm(this.$t('Pricing.NotSave'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.onSave()
        }).catch(() => {
          this.$emit('close')
        })
      } else {
        this.$emit('close')
      }
    },
    isValid() {
      if (this.source !== null && this.source.length > 1) { // 检查起运地或目的地是否为空
        // 检查是否存在重复项
        const len = this.source.length
        const len1 = len - 1
        let isOverlap = false
        for (let i = 0; i < len1; i++) {
          for (let j = i + 1; j < len; j++) {
            if (this.source[i].isOverlap(this.source[j])) {
              this.source[i]['repeat'] = true
              this.source[j]['repeat'] = true
              isOverlap = true
              break
            }
          }
        }
        if (isOverlap) {
          this.gridOptions.api.forEachLeafNode((node) => {
            if (node.data['repeat']) {
              node.setSelected(true)
              delete node.data.repeat
            }
          })
          this.$message.warning(this.$t('Pricing.SettingOverlap'))
          return false
        }
      }
      return true
    }
  }
}
</script>

<style  lang="scss" scoped>
  .tab-fcl-setting {
    .search{
      display: flex;flex: 1;
      position: absolute;
      right:0;
      top: 0;
      margin-right: 20px;
      margin-top: 10px;
      .label-center{
        align-self:center;
        margin-right: 5px;
      }
    }
  }
</style>
